import { useQuery } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { subscriptionService } from 'services';

interface useSubscriptionProductOptions {
  enabled?: boolean;
}

export const useSubscriptionProduct = (
  options?: useSubscriptionProductOptions
) => {
  return useQuery(
    ServerStateKeysEnum.subscriptionProductList,
    () => subscriptionService.getSubscriptionProducts(),
    {
      staleTime: Infinity,
      enabled: options?.enabled ?? true,
    }
  );
};
